import {connect} from 'react-redux'
import * as actInvoices from 'actions/reports/invoices'
import AmountToRefund from 'components/receipt/refunds/AmountToRefund'
import RefundReason from 'components/receipt/refunds/RefundReason'
import {Modal} from 'react-bootstrap'
import ModalHeader from 'components/Modal/ModalHeader'

class OldCancelInvoiceModal extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      reason: '',
      otherReason: '',
      sending: false
    }
  }

  render () {
    let {openOldCancelInvoiceModal} = this.props.data.reports.invoices
    return (<Modal show={openOldCancelInvoiceModal} onHide={this._onHide} bsClass='old-cancel-invoice full-height-modal margin-top-modal modal'>
      <ModalHeader title='Cancel Invoice' />
      <Modal.Body>
        <AmountToRefund calculateAmountToRefund={this._calculateAmountToRefund} />
        <RefundReason
          labelReason='Reason for Cancelation'
          onChangeReasonForRefund={this._onChangeReasonForRefund}
          onChangeOtherReasonForRefund={this._onChangeReasonOtherReason} />
      </Modal.Body>
      <Modal.Footer>
        <button className='btn btn-default mr-10px pull-left' onClick={this._onHide} type='button'>Cancel</button>
        <button className='btn btn-primary pull-right' type='submit' disabled={!this._canIssueRefund()} onClick={this._onSubmit}>
          Cancel Invoice
        </button>
      </Modal.Footer>
    </Modal>)
  }

  _calculateAmountToRefund = () => {
    let {receiptInvoices} = this.props.data.reports.invoices
    return receiptInvoices.total_collected
  };

  _canIssueRefund = () => {
    // refund reason is not empty, and if refundReason is 'Other', customReason is not empty
    return (this.state.reason && (this.state.reason !== 'Other' || this.state.otherReason) && !this.state.sending)
  };

  _onChangeReasonForRefund = (value) => {
    this.setState({reason: value})
  };

  _onChangeReasonOtherReason = (value) => {
    this.setState({otherReason: value})
  };

  _onSubmit = () => {
    this.setState({sending: true})
    let {receiptInvoices} = this.props.data.reports.invoices
    let data = {
      refund: {
        'amount': this._calculateAmountToRefund(),
        'reason': this.state.reason !== 'Other' ? this.state.reason : this.state.otherReason,
        'payment_id': receiptInvoices.id,
        'custom_reason': this.state.otherReason
      }
    }
    this.props.dispatch(actInvoices.issueOldRefundRequest(data))
  };

  _onHide = () => {
    this.setState({reason: null})
    this.props.dispatch(actInvoices.hideOldCancelInvoiceModal())
  }
}

OldCancelInvoiceModal.propTypes = {

}

function mapStateToProps (state) {
  return {
    data: {
      reports: {
        invoices: state.reports.invoices
      }
    }
  }
}
export default connect(mapStateToProps)(OldCancelInvoiceModal)



// WEBPACK FOOTER //
// ./app/components/receipt/refunds/OldCancelInvoiceModal/OldCancelInvoiceModal.js